import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, Area, AreaChart
} from 'recharts';
import { usePlatformFeeGrowth } from '@hooks/dashboard/useKapi';
import { PlatformFeeData } from 'types/dashboard/dashboardTypes';

const LineGraph: React.FC = () => {
  const { data: platformFees, isLoading } = usePlatformFeeGrowth();

  if (isLoading) return <div className="chart-loading">Loading chart...</div>;

  const chartData = platformFees
    ? platformFees.map((item: PlatformFeeData) => ({
        date: item.date,
        platformFee: item.platformFee,
      }))
    : Array.from({ length: 30 }, (_, i) => ({ date: `Day ${i + 1}`, platformFee: 15.0 }));

  return (
    <ResponsiveContainer width="100%" height={320}>
      <AreaChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id="platformFeeGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#6366F1" stopOpacity={0.15}/>
            <stop offset="95%" stopColor="#6366F1" stopOpacity={0}/>
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#F3F4F6" vertical={false} />
        <XAxis dataKey="date" tick={{ fontSize: 11, fill: '#9CA3AF' }} axisLine={false} tickLine={false} />
        <YAxis tick={{ fontSize: 11, fill: '#9CA3AF' }} axisLine={false} tickLine={false} />
        <Tooltip
          contentStyle={{ background: '#0B1829', border: 'none', borderRadius: 10, color: '#fff', fontSize: 12, boxShadow: '0 8px 24px rgba(0,0,0,0.2)' }}
          labelStyle={{ color: '#84EEFC', fontWeight: 600, marginBottom: 4 }}
          itemStyle={{ color: '#fff' }}
        />
        <Area
          type="monotone"
          dataKey="platformFee"
          stroke="#6366F1"
          fill="url(#platformFeeGrad)"
          strokeWidth={2.5}
          dot={false}
          activeDot={{ r: 5, fill: '#6366F1', stroke: '#fff', strokeWidth: 2 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default LineGraph;